import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { insurancesShape } from 'constants/propTypes';

import { Row, Column } from 'components/shared/Layout';

import Insurance from './Insurance';
import ManageInsurance from './ManageInsurance';

import { StyledExtrasContainer } from '../Extras.styles';

import { hasItem } from '../Extras.utils';

const ExtrasInsurance = ({ insurances, bookingReference }) => (
  <Row span={14} start={2}>
    <h1>
      <FormattedMessage id="extras.insurance.title" />
    </h1>
    {hasItem(insurances) ? (
      <StyledExtrasContainer>
        {insurances.map(
          (insurance) =>
            !insurance.cancelled && (
              <Insurance key={insurance.itemRef} insurance={insurance}>
                <ManageInsurance
                  bookingReference={bookingReference}
                  passenger={`${insurance.passenger.firstName} ${insurance.passenger.lastName}`}
                  date={insurance.date}
                  policyNumber={insurance.policyNumber}
                  currency={insurance.currency}
                  price={insurance.price}
                  itemRef={insurance.itemRef}
                />
              </Insurance>
            )
        )}
      </StyledExtrasContainer>
    ) : (
      <Column>
        <FormattedMessage id="extras.noInsuranceProductsBookingLevel" />
      </Column>
    )}
  </Row>
);

ExtrasInsurance.propTypes = {
  insurances: insurancesShape.isRequired,
  bookingReference: PropTypes.string.isRequired
};

export default ExtrasInsurance;
